import { Table, Button } from "react-bootstrap";

import { MultiMprnTableProps } from "../../types/components.types";
import { downloadMultiMprnCSV } from "../../utils/gaslink/gaslink.csv";
import { flattenGasMeterDetailsForTable } from "../../utils/gaslink/gaslink.utils";

const MultiMprnTable: React.FC<MultiMprnTableProps> = ({ results }) => {
  // Track the total number of MPRNs returned to determine the layout logic rendered on the UI.
  const mprnCount = results.length;

  const tableData = flattenGasMeterDetailsForTable(results);

  // Filter out rows where all values are empty or have errored. Keep only the rows with valid data.
  const filteredRows = tableData.rows.filter((row) =>
    row.values.some((value) => value.display !== "" && !value.isError),
  );

  // For 5+ MPRNs: only show the "download CSV" button (no table).
  const isFivePlusMprns = mprnCount > 5;

  if (isFivePlusMprns) {
    return (
      <div className="multi-mpan-results">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>Search Results ({results.length} MPRNs)</h5>
          <Button
            variant="primary"
            onClick={() => {
              downloadMultiMprnCSV(results);
            }}
          >
            Download CSV
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="multi-mpan-results">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Search Results ({results.length} MPRNs)</h5>
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            onClick={() => {
              downloadMultiMprnCSV(results);
            }}
          >
            Download CSV
          </Button>
        </div>
      </div>

      <div className="multi-mpan-table-container">
        <Table striped bordered hover>
          <thead>
            <tr>
              {/* Freeze the left column, so it stays visible when scrolling. */}
              <th className="sticky-field-column" rowSpan={2}>
                Field
              </th>
              <th colSpan={tableData.columns.length} className="text-center">
                MPRN
              </th>
            </tr>
            <tr>
              {tableData.columns.map((column) => (
                <th key={column.mprn} className={column.hasError ? "error-column" : ""}>
                  {column.mprn}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* One row per data field. */}
            {filteredRows.map((row) => (
              <tr key={row.field}>
                <td className="sticky-field-column">{row.field}</td>
                {row.values.map((value, index) => (
                  <td key={index} className={value.isError ? "text-danger" : ""}>
                    {value.display}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default MultiMprnTable;
